import Titulo from './fonts/TituloPrincipal';
import Autocomplete from './UIElements/Autocomplete';
import TextField from './UIElements/TextField';
import { useState, useEffect, useRef } from 'react';
import { getCursos } from "../services/cursos.service.js";
import { getMediosInscripcion } from "../services/mediosInscripcion.service.js";
import { getPlataformasDictado } from "../services/plataformasDictado.service.js";
import { getTiposCapacitacion } from "../services/tiposCapacitacion.service.js";
import { getMyUser } from "../services/usuarios.service.js";
import Cohortes from "./Cohortes.jsx";
import validarFecha from '../services/validarFechas.js';
import { postInstancias, getCachedCalendarioRestricciones, getInstanciasByCurso } from "../services/instancias.service.js";
import dayjs from 'dayjs';
import Backdrop from '@mui/material/Backdrop';
import BurbujasLoader from './UIElements/BurbujasLoader';
import Divider from '@mui/material/Divider';
import { validarOrdenFechas } from "../services/validarOrdenFechas.js";
import { useNavigate } from 'react-router-dom';
import OpcionesEvento from './OpcionesEvento.jsx';
import NuevoEvento from './NuevoEvento.jsx';
import Alerta from "./UIElements/Dialog.jsx";
import { getDepartamentos } from "../services/departamentos.service.js";
import { useFeedbackModalContext } from '../context/FeedbackModalContext';
import { Autocomplete as MuiAutocomplete, TextField as MuiTextField, MenuItem, Box, Container, Button as MuiButton, Stack, Grid, Typography } from '@mui/material';

export default function Formulario() {

  const navigate = useNavigate();
  const { showSuccess, showError, showWarning } = useFeedbackModalContext();

  const [cursos, setCursos] = useState([]);
  const [mediosInscripcion, setMediosInscripciones] = useState([]);
  const [plataformasDictado, setPlataformasDictado] = useState([]);
  const [tiposCapacitaciones, setTiposCapacitaciones] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [cargando, setCargando] = useState(false);

  const [selectCurso, setSelectCurso] = useState("");
  const [selectMedioInscripcion, setSelectMedioInscripcion] = useState("");
  const [selectPlataformaDictado, setSelectPlataformaDictado] = useState("");
  const [selectTipoCapacitacion, setSelectTipoCapacitacion] = useState("");
  const [cupo, setCupo] = useState("");
  const [horas, setHoras] = useState("");
  const [cohortes, setCohortes] = useState([]);
  const [edadDesde, setEdadDesde] = useState(16);
  const [edadHasta, setEdadHasta] = useState("Sin Restricción");
  const [departamentosSeleccionados, setDepartamentosSeleccionados] = useState([]);
  const [cursosCorrelativosSeleccionados, setCursosCorrelativosSeleccionados] = useState([]);

  const [opciones, setOpciones] = useState({
    autogestionado: false,
    edad: false,
    departamento: false,
    publicaPCC: false,
    correlatividad: false
  });

  const [esCampusCordoba, setEsCampusCordoba] = useState(false);
  const [esExcepcionParaFechas, setEsExcepcionParaFechas] = useState(false);
  const [instanciasExistentes, setInstanciasExistentes] = useState([]);

  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [tituloAlerta, setTituloAlerta] = useState('');
  const [mensajeAlerta, setMensajeAlerta] = useState('');

  const [resetCohortesKey, setResetCohortesKey] = useState(0);
  const [nuevoEvento, setNuevoEvento] = useState(false);

  const [fieldErrors, setFieldErrors] = useState({});
  const [erroresCohortes, setErroresCohortes] = useState({});
  const fieldRefs = useRef({});

  const clearFieldError = (fieldKey) => {
    setFieldErrors((prev) => {
      if (!prev[fieldKey]) return prev;
      const next = { ...prev };
      delete next[fieldKey];
      return next;
    });
  };

  const calcularErroresDeCohorte = (cohorte, index, listaCohortes, exigirCamposVacios = false) => {
    const errCohorte = {};
    const codPlataforma = plataformasDictado.find(plataforma => plataforma.nombre === selectPlataformaDictado)?.cod;
    const aplicaReglaCampusCordoba = esCampusCordoba || codPlataforma === 'CC';
    const cachedRestricciones = getCachedCalendarioRestricciones();
    const ventanaInicio = cachedRestricciones?.ventanaInicio ?? 0;

    const tieneInscDesde = validarFecha(cohorte.fechaInscripcionDesde);
    const tieneInscHasta = validarFecha(cohorte.fechaInscripcionHasta);
    const tieneCursDesde = validarFecha(cohorte.fechaCursadaDesde);
    const tieneCursHasta = validarFecha(cohorte.fechaCursadaHasta);

    if (exigirCamposVacios) {
      if (!tieneInscDesde) errCohorte.fechaInscripcionDesde = 'Seleccione la fecha de inicio de inscripción.';
      if (!tieneInscHasta) errCohorte.fechaInscripcionHasta = 'Seleccione la fecha de fin de inscripción.';
      if (!tieneCursDesde) errCohorte.fechaCursadaDesde = 'Seleccione la fecha de inicio de cursada.';
      if (!tieneCursHasta) errCohorte.fechaCursadaHasta = 'Seleccione la fecha de fin de cursada.';
    }

    // Validación de orden cronológico sobre las fechas ya ingresadas
    if (!opciones.autogestionado) {
      if (tieneInscDesde && tieneInscHasta && cohorte.fechaInscripcionDesde >= cohorte.fechaInscripcionHasta) {
        errCohorte.fechaInscripcionHasta = 'Debe ser posterior al inicio de inscripción.';
      }
      if (tieneInscHasta && tieneCursDesde && cohorte.fechaInscripcionHasta >= cohorte.fechaCursadaDesde) {
        errCohorte.fechaInscripcionHasta = 'Debe finalizar antes del inicio de cursada.';
        errCohorte.fechaCursadaDesde = 'Debe ser posterior al fin de inscripción.';
      }
      if (tieneCursDesde && tieneCursHasta && cohorte.fechaCursadaDesde >= cohorte.fechaCursadaHasta) {
        errCohorte.fechaCursadaHasta = 'Debe ser posterior al inicio de cursada.';
      }
    } else {
      if (tieneInscDesde && tieneCursHasta && cohorte.fechaInscripcionDesde > cohorte.fechaCursadaHasta) {
        errCohorte.fechaInscripcionDesde = 'No puede superar la fecha de fin de cursada.';
      }
      if (tieneInscHasta) {
        if (
          (tieneInscDesde && cohorte.fechaInscripcionHasta <= cohorte.fechaInscripcionDesde) ||
          (tieneCursHasta && cohorte.fechaInscripcionHasta > cohorte.fechaCursadaHasta)
        ) {
          errCohorte.fechaInscripcionHasta = 'Debe ser posterior al inicio de inscripción y no superar el fin de cursada.';
        }
      }
      if (tieneCursDesde) {
        if (
          (tieneInscDesde && cohorte.fechaCursadaDesde < cohorte.fechaInscripcionDesde) ||
          (tieneCursHasta && cohorte.fechaCursadaDesde >= cohorte.fechaCursadaHasta)
        ) {
          errCohorte.fechaCursadaDesde = 'Debe ubicarse entre el inicio de inscripción y antes del fin de cursada.';
        }
      }
    }

    // Validación de fecha de inicio exacta duplicada en BD para el mismo curso (aplica a todos los usuarios)
    if (tieneCursDesde && Array.isArray(instanciasExistentes) && instanciasExistentes.length > 0) {
      const duplicada = instanciasExistentes.find(
        (instDB) => instDB.estado_instancia !== 'CANC' && instDB.fecha_inicio_curso === cohorte.fechaCursadaDesde
      );
      if (duplicada) {
        errCohorte.fechaCursadaDesde = `Ya existe una cohorte para este curso con inicio el ${dayjs(cohorte.fechaCursadaDesde).format('DD/MM/YYYY')}.`;
      }
    }

    if (!esExcepcionParaFechas) {
      // Validación de ventanaInicio desde hoy
      if (tieneCursDesde && ventanaInicio > 0) {
        const minInicioHoy = dayjs().startOf('day').add(ventanaInicio + 1, 'day');
        if (dayjs(cohorte.fechaCursadaDesde).isBefore(minInicioHoy, 'day')) {
          errCohorte.fechaCursadaDesde = `La fecha de inicio de cursada (${cohorte.fechaCursadaDesde}) se encuentra dentro de la ventana de inicio de ${ventanaInicio} días (mín. ${minInicioHoy.format('DD/MM/YYYY')}).`;
        }
      }

      // Validación de ventanaInicio respecto a la cohorte anterior
      if (index > 0 && tieneCursDesde) {
        const cohorteAnterior = listaCohortes[index - 1];
        if (validarFecha(cohorteAnterior.fechaCursadaHasta)) {
          const minInicioSiguiente = dayjs(cohorteAnterior.fechaCursadaHasta).add(ventanaInicio + 1, 'day');
          if (dayjs(cohorte.fechaCursadaDesde).isBefore(minInicioSiguiente, 'day')) {
            errCohorte.fechaCursadaDesde = `Debe respetar ${ventanaInicio} días tras la Cohorte N° ${index} (mín. ${minInicioSiguiente.format('DD/MM/YYYY')}).`;
          }
        }
      }

      // Validación de ventanaInicio y no solapamiento contra cohortes existentes en BD del mismo curso
      if (Array.isArray(instanciasExistentes) && instanciasExistentes.length > 0) {
        const fcDesde = tieneCursDesde ? dayjs(cohorte.fechaCursadaDesde) : null;
        const fcHasta = tieneCursHasta ? dayjs(cohorte.fechaCursadaHasta) : null;

        for (const instDB of instanciasExistentes) {
          if (instDB.estado_instancia === 'CANC' || !instDB.fecha_inicio_curso || !instDB.fecha_fin_curso) continue;

          const dbInicio = dayjs(instDB.fecha_inicio_curso);
          const dbFin = dayjs(instDB.fecha_fin_curso);
          const rangoTexto = `${dbInicio.format('DD/MM/YYYY')} al ${dbFin.format('DD/MM/YYYY')}`;

          if (fcDesde) {
            if (!fcDesde.isBefore(dbInicio, 'day') && !fcDesde.isAfter(dbFin, 'day')) {
              errCohorte.fechaCursadaDesde = `Se superpone con una cohorte existente del curso (${rangoTexto}).`;
            } else if (fcDesde.isAfter(dbFin, 'day') && fcDesde.diff(dbFin, 'day') <= ventanaInicio) {
              const minPermitida = dbFin.add(ventanaInicio + 1, 'day').format('DD/MM/YYYY');
              errCohorte.fechaCursadaDesde = `Debe respetar ${ventanaInicio} días tras la cohorte existente (${rangoTexto}). Mín. ${minPermitida}.`;
            }
          }

          if (fcHasta) {
            if (!fcHasta.isBefore(dbInicio, 'day') && !fcHasta.isAfter(dbFin, 'day')) {
              errCohorte.fechaCursadaHasta = `No puede estar dentro del rango de una cohorte existente (${rangoTexto}).`;
            } else if (fcDesde && fcDesde.isBefore(dbInicio, 'day')) {
              if (fcHasta.isAfter(dbFin, 'day')) {
                errCohorte.fechaCursadaHasta = `El rango envuelve a una cohorte existente (${rangoTexto}).`;
              } else if (dbInicio.diff(fcHasta, 'day') <= ventanaInicio) {
                const maxPermitida = dbInicio.subtract(ventanaInicio + 1, 'day').format('DD/MM/YYYY');
                errCohorte.fechaCursadaHasta = `Debe finalizar al menos ${ventanaInicio} días antes de la cohorte existente (${rangoTexto}). Máx. ${maxPermitida}.`;
              }
            }
          }
        }
      }

      // Validación de máximo 90 días para Campus Córdoba
      if (aplicaReglaCampusCordoba && tieneCursDesde && tieneCursHasta) {
        const duracionDias = dayjs(cohorte.fechaCursadaHasta).diff(dayjs(cohorte.fechaCursadaDesde), 'day');
        if (duracionDias > 90) {
          const maxFechaPermitida = dayjs(cohorte.fechaCursadaDesde).add(90, 'day').format('DD/MM/YYYY');
          errCohorte.fechaCursadaHasta = `Supera los 90 días máx. de Campus Córdoba (${duracionDias} días). Elija hasta el ${maxFechaPermitida}.`;
        }
      }
    }

    return errCohorte;
  };

  const revalidarCohortesEnVivo = (listaCohortes) => {
    setErroresCohortes((prev) => {
      const next = {};
      listaCohortes.forEach((cohorte, idx) => {
        const prevErrorsForCohorte = prev[cohorte.id] || {};
        const calculados = calcularErroresDeCohorte(cohorte, idx, listaCohortes, false);

        // Si un campo sigue vacío y ya tenía el aviso de campo vacío, lo conservamos;
        // si ya tiene fecha o cambió, usamos únicamente el resultado recalculado en vivo.
        ['fechaInscripcionDesde', 'fechaInscripcionHasta', 'fechaCursadaDesde', 'fechaCursadaHasta'].forEach((campo) => {
          if (calculados[campo]) {
            if (!next[cohorte.id]) next[cohorte.id] = {};
            next[cohorte.id][campo] = calculados[campo];
          } else if (!validarFecha(cohorte[campo]) && prevErrorsForCohorte[campo]?.startsWith('Seleccione la fecha')) {
            if (!next[cohorte.id]) next[cohorte.id] = {};
            next[cohorte.id][campo] = prevErrorsForCohorte[campo];
          }
        });
      });
      return next;
    });
  };

  const focusField = (fieldKey) => {
    setTimeout(() => {
      const target = fieldRefs.current[fieldKey];
      if (target) {
        if (typeof target.scrollIntoView === 'function') {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        const errorInput =
          fieldKey === 'cohortesSection'
            ? target.querySelector('.Mui-error input') || target.querySelector('input')
            : target;
        if (errorInput && typeof errorInput.focus === 'function') {
          errorInput.focus();
        }
      }
    }, 120);
  };

  const manejarCambioOpciones = (nuevaOpciones) => {
    setOpciones(nuevaOpciones);
    if (!nuevaOpciones.edad) { setEdadDesde(16); setEdadHasta("Sin Restricción"); }
    if (!nuevaOpciones.departamento) {
      setDepartamentosSeleccionados([]);
      clearFieldError('departamentos');
    }
    if (!nuevaOpciones.correlatividad) {
      setCursosCorrelativosSeleccionados([]);
      clearFieldError('correlatividad');
    }
  };

  useEffect(() => {
    const cursoObj = cursos.find(c => c.nombre === selectCurso);
    const plataformaObj = plataformasDictado.find(p => p.nombre === selectPlataformaDictado);
    const esCC = (cursoObj?.cod?.startsWith('C-')) || (plataformaObj?.cod === 'CC');
    setEsCampusCordoba(esCC);
  }, [selectCurso, selectPlataformaDictado, cursos, plataformasDictado]);

  useEffect(() => {
    const codCurso = cursos.find((c) => c.nombre === selectCurso)?.cod;
    if (!codCurso) {
      setInstanciasExistentes([]);
      return;
    }
    let active = true;
    getInstanciasByCurso(codCurso).then((data) => {
      if (active) {
        setInstanciasExistentes(data);
      }
    });
    return () => {
      active = false;
    };
  }, [selectCurso, cursos]);

  useEffect(() => {
    if (cohortes.length > 0 && (Object.keys(erroresCohortes).length > 0 || instanciasExistentes.length > 0)) {
      revalidarCohortesEnVivo(cohortes);
    }
  }, [esCampusCordoba, esExcepcionParaFechas, opciones.autogestionado, instanciasExistentes]);

  useEffect(() => {
    (async () => {
      try {
        const user = await getMyUser(); if (!user.cuil) { navigate("/login"); return; }
        setEsExcepcionParaFechas(user.esExcepcionParaFechas === 1 || user.esExcepcionParaFechas === true);
        if (nuevoEvento) return;
        const [
          listaCursos,
          listaMediosInscripciones,
          listaPlataformasDictados,
          listaTiposCapacitacion,
          listaDepartamentos,
        ] = await Promise.all([
          getCursos(),
          getMediosInscripcion(),
          getPlataformasDictado(),
          getTiposCapacitacion(),
          getDepartamentos(),
        ]);
        setCursos(listaCursos.sort((a, b) => a.nombre.localeCompare(b.nombre)));
        setMediosInscripciones(listaMediosInscripciones.sort((a, b) => a.nombre.localeCompare(b.nombre)));
        setPlataformasDictado(listaPlataformasDictados.sort((a, b) => a.nombre.localeCompare(b.nombre)));
        setTiposCapacitaciones(listaTiposCapacitacion.sort((a, b) => a.nombre.localeCompare(b.nombre)));
        setDepartamentos(listaDepartamentos.sort((a, b) => a.nombre.localeCompare(b.nombre)));
      } catch (err) {
        showError({
          title: 'Error al cargar los datos',
          description: 'No se pudieron obtener los catálogos necesarios para el formulario.',
          detail: err.message || 'Verifique su conexión e intente recargar la página.',
          confirmText: 'Entendido',
        });
      }
    })();
  }, [nuevoEvento, navigate, showError]);

  const limpiarFormularioCompleto = () => {
    setSelectCurso(""); setSelectMedioInscripcion("");
    setSelectPlataformaDictado(""); setSelectTipoCapacitacion(""); setCupo(""); setHoras("");
    setCohortes([]); setEdadDesde(16); setEdadHasta("Sin Restricción"); setDepartamentosSeleccionados([]);
    setCursosCorrelativosSeleccionados([]);
    setOpciones({ autogestionado: false, edad: false, departamento: false, publicaPCC: false, correlatividad: false });
    setFieldErrors({});
    setErroresCohortes({});
    setResetCohortesKey(prevKey => prevKey + 1);
  };



  const handleEventoCreado = (codCurso) => {
    setCursos(prevCursos => prevCursos.map(curso =>
      curso.cod === codCurso ? { ...curso, tiene_evento_creado: 1 } : curso
    ));
    setNuevoEvento(false);
  };

  const handleCohortes = (cohortes) => { setCohortes(cohortes); };

  const validarFormulario = () => {
    const nuevosErrores = {};
    const nuevosErroresCohortes = {};
    const camposFaltantes = [];
    let firstFocusKey = null;

    const registerError = (key, message, label, hint) => {
      nuevosErrores[key] = message;
      if (!firstFocusKey) firstFocusKey = key;
      if (label) {
        camposFaltantes.push({ key, label, hint });
      }
    };

    if (!selectCurso) {
      registerError(
        'curso',
        'Seleccione un curso de la lista para asociar la cohorte.',
        'Curso',
        'Seleccione el curso para el cual desea crear la cohorte.'
      );
    }
    if (!selectMedioInscripcion) {
      registerError(
        'medioInscripcion',
        'Seleccione un medio de inscripción vigente.',
        'Medio de inscripción',
        'Indique el canal por el cual se inscribirán los participantes.'
      );
    }
    if (!selectPlataformaDictado) {
      registerError(
        'plataformaDictado',
        'Seleccione la plataforma donde se dictará el curso.',
        'Plataforma de dictado',
        'Seleccione la plataforma donde se dictará la capacitación.'
      );
    }
    if (!selectTipoCapacitacion) {
      registerError(
        'tipoCapacitacion',
        'Seleccione la modalidad o tipo de capacitación.',
        'Tipo de capacitación',
        'Indique la modalidad de la capacitación.'
      );
    }
    if (!cupo) {
      registerError(
        'cupo',
        'Ingrese un número entero mayor a 0 para definir el cupo.',
        'Cupo',
        'Ingrese la cantidad máxima de inscriptos (entero mayor a 0).'
      );
    } else if (!/^[1-9]\d*$/.test(cupo.toString())) {
      registerError('cupo', 'El cupo debe ser un número entero positivo mayor a 0.');
    }

    if (!horas) {
      registerError(
        'horas',
        'Ingrese la carga horaria total (entero mayor a 0).',
        'Cantidad de horas',
        'Ingrese la carga horaria total del curso (entero mayor a 0).'
      );
    } else if (!/^[1-9]\d*$/.test(horas.toString())) {
      registerError('horas', 'La cantidad de horas debe ser un número entero mayor a 0.');
    }

    if (opciones.departamento && departamentosSeleccionados.length === 0) {
      registerError(
        'departamentos',
        'Seleccione al menos un departamento o desactive esta restricción.',
        'Departamentos',
        'Activó la restricción por departamento pero no seleccionó ninguno.'
      );
    }
    if (opciones.correlatividad && cursosCorrelativosSeleccionados.length === 0) {
      registerError(
        'correlatividad',
        'Seleccione al menos un curso correlativo o desactive esta restricción.',
        'Cursos correlativos',
        'Activó la restricción de correlatividad pero no seleccionó ningún curso.'
      );
    }

    if (cohortes.length === 0) {
      nuevosErrores.sinCohortes = 'Debe agregar al menos una cohorte haciendo clic en "+ Agregar Cohorte".';
      if (!firstFocusKey) firstFocusKey = 'cohortesSection';
    }

    const codPlataforma = plataformasDictado.find(plataforma => plataforma.nombre === selectPlataformaDictado)?.cod;
    const aplicaReglaCampusCordoba = esCampusCordoba || codPlataforma === 'CC';
    const cachedRestricciones = getCachedCalendarioRestricciones();
    const ventanaInicio = cachedRestricciones?.ventanaInicio ?? 0;

    let modalCohortError = null;

    for (let index = 0; index < cohortes.length; index++) {
      const cohorte = cohortes[index];
      const errCohorte = {};
      const faltantesCohorte = [];

      if (!validarFecha(cohorte.fechaInscripcionDesde)) {
        errCohorte.fechaInscripcionDesde = 'Seleccione la fecha de inicio de inscripción.';
        faltantesCohorte.push('Inscripción desde');
      }
      if (!validarFecha(cohorte.fechaInscripcionHasta)) {
        errCohorte.fechaInscripcionHasta = 'Seleccione la fecha de fin de inscripción.';
        faltantesCohorte.push('Inscripción hasta');
      }
      if (!validarFecha(cohorte.fechaCursadaDesde)) {
        errCohorte.fechaCursadaDesde = 'Seleccione la fecha de inicio de cursada.';
        faltantesCohorte.push('Cursada desde');
      }
      if (!validarFecha(cohorte.fechaCursadaHasta)) {
        errCohorte.fechaCursadaHasta = 'Seleccione la fecha de fin de cursada.';
        faltantesCohorte.push('Cursada hasta');
      }

      if (faltantesCohorte.length > 0) {
        nuevosErroresCohortes[cohorte.id] = errCohorte;
        if (!firstFocusKey) firstFocusKey = 'cohortesSection';
        if (!modalCohortError) {
          modalCohortError = {
            modalType: 'warning',
            title: `Fechas incompletas en Cohorte N° ${index + 1}`,
            description: 'Todos los campos de fecha de la cohorte deben estar completos.',
            detail: {
              text: 'Falta seleccionar:',
              highlight: faltantesCohorte.join(', '),
              subtext: `Complete los campos marcados en rojo en la Cohorte N° ${index + 1}.`,
            },
            ringBadge: true,
            confirmText: 'Completar fechas',
          };
        }
        continue;
      }

      try {
        validarOrdenFechas(
          [cohorte.fechaInscripcionDesde, cohorte.fechaInscripcionHasta, cohorte.fechaCursadaDesde, cohorte.fechaCursadaHasta],
          opciones.autogestionado
        );
      } catch (ordenError) {
        if (!opciones.autogestionado) {
          if (cohorte.fechaInscripcionDesde > cohorte.fechaInscripcionHasta) {
            errCohorte.fechaInscripcionHasta = 'No puede ser anterior al inicio de inscripción.';
          } else if (cohorte.fechaInscripcionHasta >= cohorte.fechaCursadaDesde) {
            errCohorte.fechaInscripcionHasta = 'Debe finalizar antes del inicio de cursada.';
            errCohorte.fechaCursadaDesde = 'Debe ser posterior al fin de inscripción.';
          } else if (cohorte.fechaCursadaDesde > cohorte.fechaCursadaHasta) {
            errCohorte.fechaCursadaHasta = 'No puede ser anterior al inicio de cursada.';
          }
        } else {
          if (cohorte.fechaInscripcionDesde > cohorte.fechaCursadaHasta) {
            errCohorte.fechaInscripcionDesde = 'No puede superar la fecha de fin de cursada.';
          }
          if (cohorte.fechaInscripcionHasta < cohorte.fechaInscripcionDesde || cohorte.fechaInscripcionHasta > cohorte.fechaCursadaHasta) {
            errCohorte.fechaInscripcionHasta = 'Debe ubicarse entre inicio de inscripción y fin de cursada.';
          }
          if (cohorte.fechaCursadaDesde < cohorte.fechaInscripcionDesde || cohorte.fechaCursadaDesde > cohorte.fechaCursadaHasta) {
            errCohorte.fechaCursadaDesde = 'Debe ubicarse entre inicio de inscripción y fin de cursada.';
          }
        }
        nuevosErroresCohortes[cohorte.id] = errCohorte;
        if (!firstFocusKey) firstFocusKey = 'cohortesSection';
        if (!modalCohortError) {
          modalCohortError = {
            modalType: 'error',
            title: `Error de cronología en Cohorte N° ${index + 1}`,
            description: ordenError.message,
            detail: {
              text: 'Cohorte afectada:',
              highlight: `Cohorte N° ${index + 1}`,
              subtext: 'Modifique las fechas resaltadas en rojo según la leyenda indicada.',
            },
            confirmText: 'Corregir fechas',
          };
        }
      }

      if (Array.isArray(instanciasExistentes) && instanciasExistentes.length > 0) {
        const duplicada = instanciasExistentes.find(
          (instDB) => instDB.estado_instancia !== 'CANC' && instDB.fecha_inicio_curso === cohorte.fechaCursadaDesde
        );
        if (duplicada) {
          const fechaFormato = dayjs(cohorte.fechaCursadaDesde).format('DD/MM/YYYY');
          errCohorte.fechaCursadaDesde = `Ya existe una cohorte para este curso con inicio el ${fechaFormato}.`;
          nuevosErroresCohortes[cohorte.id] = errCohorte;
          if (!firstFocusKey) firstFocusKey = 'cohortesSection';
          if (!modalCohortError) {
            modalCohortError = {
              modalType: 'error',
              title: 'Fecha de inicio duplicada',
              description: `Ya existe una cohorte registrada para este curso con fecha de inicio de cursada ${fechaFormato}.`,
              detail: {
                text: `Cohorte N° ${index + 1}:`,
                highlight: fechaFormato,
                subtext: 'Seleccione otra fecha de inicio de cursada.',
              },
              confirmText: 'Ajustar fecha',
            };
          }
        }
      }

      if (!esExcepcionParaFechas) {
        if (aplicaReglaCampusCordoba) {
          const duracionDias = dayjs(cohorte.fechaCursadaHasta).diff(dayjs(cohorte.fechaCursadaDesde), 'day');
          if (duracionDias > 90) {
            const maxFechaPermitida = dayjs(cohorte.fechaCursadaDesde).add(90, 'day').format('DD/MM/YYYY');
            errCohorte.fechaCursadaHasta = `Supera los 90 días máx. de Campus Córdoba (${duracionDias} días).Elija hasta el ${maxFechaPermitida}.`;
            nuevosErroresCohortes[cohorte.id] = errCohorte;
            if (!firstFocusKey) firstFocusKey = 'cohortesSection';
            if (!modalCohortError) {
              modalCohortError = {
                modalType: 'error',
                title: 'Duración máxima superada',
                description: 'Para Campus Córdoba, una cohorte no puede durar más de 90 días corridos.',
                detail: {
                  text: `Cohorte N° ${index + 1}:`,
                  highlight: `${duracionDias} días corridos`,
                  subtext: `Seleccione una fecha de fin hasta el ${maxFechaPermitida} como máximo.`,
                },
                confirmText: 'Ajustar fecha',
              };
            }
          }
        }

        if (ventanaInicio > 0) {
          const minInicioHoy = dayjs().startOf('day').add(ventanaInicio + 1, 'day');
          if (dayjs(cohorte.fechaCursadaDesde).isBefore(minInicioHoy, 'day')) {
            errCohorte.fechaCursadaDesde = `La fecha de inicio de cursada (${cohorte.fechaCursadaDesde}) se encuentra dentro de la ventana de inicio de ${ventanaInicio} días (mín. ${minInicioHoy.format('DD/MM/YYYY')}).`;
            nuevosErroresCohortes[cohorte.id] = errCohorte;
            if (!firstFocusKey) firstFocusKey = 'cohortesSection';
            if (!modalCohortError) {
              modalCohortError = {
                modalType: 'error',
                title: 'Dentro de la ventana de inicio',
                description: `La fecha de inicio de cursada (${dayjs(cohorte.fechaCursadaDesde).format('DD/MM/YYYY')}) se encuentra dentro de la ventana de inicio de ${ventanaInicio} días.`,
                detail: {
                  text: 'Primera fecha habilitada:',
                  highlight: minInicioHoy.format('DD/MM/YYYY'),
                  subtext: `Seleccione una fecha de inicio a partir del ${minInicioHoy.format('DD/MM/YYYY')}.`,
                },
                confirmText: 'Ajustar fecha',
              };
            }
          }
        }

        if (Array.isArray(instanciasExistentes) && instanciasExistentes.length > 0) {
          const fcDesde = dayjs(cohorte.fechaCursadaDesde);
          const fcHasta = dayjs(cohorte.fechaCursadaHasta);

          for (const instDB of instanciasExistentes) {
            if (instDB.estado_instancia === 'CANC' || !instDB.fecha_inicio_curso || !instDB.fecha_fin_curso) continue;

            const dbInicio = dayjs(instDB.fecha_inicio_curso);
            const dbFin = dayjs(instDB.fecha_fin_curso);
            const rangoTexto = `${dbInicio.format('DD/MM/YYYY')} al ${dbFin.format('DD/MM/YYYY')}`;
            const diffPos = fcDesde.diff(dbFin, 'day');
            const diffNeg = dbInicio.diff(fcHasta, 'day');

            if (diffPos <= 0 && diffNeg <= 0) {
              if (!fcHasta.isBefore(dbInicio, 'day') && !fcHasta.isAfter(dbFin, 'day')) {
                errCohorte.fechaCursadaHasta = `No puede estar dentro del rango de una cohorte existente (${rangoTexto}).`;
              } else {
                errCohorte.fechaCursadaDesde = `Se superpone con una cohorte existente del curso (${rangoTexto}).`;
              }
              nuevosErroresCohortes[cohorte.id] = errCohorte;
              if (!firstFocusKey) firstFocusKey = 'cohortesSection';
              if (!modalCohortError) {
                modalCohortError = {
                  modalType: 'error',
                  title: 'Superposición con cohorte existente',
                  description: `Las fechas de la Cohorte N° ${index + 1} se superponen con una cohorte ya registrada para este curso.`,
                  detail: {
                    text: 'Cohorte en base de datos:',
                    highlight: rangoTexto,
                    subtext: 'La fecha de inicio o fin no puede caer dentro de este rango (incluidos los extremos).',
                  },
                  confirmText: 'Ajustar fechas',
                };
              }
            } else if (diffPos <= ventanaInicio && diffNeg <= ventanaInicio) {
              if (fcDesde.isAfter(dbFin, 'day')) {
                const minPermitida = dbFin.add(ventanaInicio + 1, 'day').format('DD/MM/YYYY');
                errCohorte.fechaCursadaDesde = `Debe respetar ${ventanaInicio} días tras la cohorte existente (${rangoTexto}). Mín. ${minPermitida}.`;
              } else {
                const maxPermitida = dbInicio.subtract(ventanaInicio + 1, 'day').format('DD/MM/YYYY');
                errCohorte.fechaCursadaHasta = `Debe finalizar al menos ${ventanaInicio} días antes de la cohorte existente (${rangoTexto}). Máx. ${maxPermitida}.`;
              }
              nuevosErroresCohortes[cohorte.id] = errCohorte;
              if (!firstFocusKey) firstFocusKey = 'cohortesSection';
              if (!modalCohortError) {
                modalCohortError = {
                  modalType: 'error',
                  title: 'Ventana de inicio con cohorte existente',
                  description: `La Cohorte N° ${index + 1} debe respetar la ventana de ${ventanaInicio} días respecto a la cohorte existente (${rangoTexto}).`,
                  detail: {
                    text: 'Cohorte existente:',
                    highlight: rangoTexto,
                    subtext: `Primera fecha habilitada posterior: ${dbFin.add(ventanaInicio + 1, 'day').format('DD/MM/YYYY')}`,
                  },
                  confirmText: 'Ajustar fechas',
                };
              }
            }
          }
        }

        if (index > 0) {
          const cohorteAnterior = cohortes[index - 1];
          if (validarFecha(cohorteAnterior.fechaCursadaHasta)) {
            const minInicioSiguiente = dayjs(cohorteAnterior.fechaCursadaHasta).add(ventanaInicio + 1, 'day');
            if (dayjs(cohorte.fechaCursadaDesde).isBefore(minInicioSiguiente, 'day')) {
              errCohorte.fechaCursadaDesde = `Debe respetar ${ventanaInicio} días tras la Cohorte N° ${index} (mín. ${minInicioSiguiente.format('DD/MM/YYYY')}).`;
              nuevosErroresCohortes[cohorte.id] = errCohorte;
              if (!firstFocusKey) firstFocusKey = 'cohortesSection';
              if (!modalCohortError) {
                modalCohortError = {
                  modalType: 'error',
                  title: 'Ventana de inicio no respetada',
                  description: `En la Cohorte N° ${index + 1}, la fecha de inicio de cursada debe respetar la ventana de ${ventanaInicio} días posterior al fin de cursada de la Cohorte N° ${index}.`,
                  detail: {
                    text: 'Primera fecha habilitada:',
                    highlight: minInicioSiguiente.format('DD/MM/YYYY'),
                    subtext: `Fin de cursada de Cohorte N° ${index}: ${dayjs(cohorteAnterior.fechaCursadaHasta).format('DD/MM/YYYY')}`,
                  },
                  confirmText: 'Ajustar fecha',
                };
              }
            }
          }
        }
      }
    }

    setFieldErrors(nuevosErrores);
    setErroresCohortes(nuevosErroresCohortes);

    if (camposFaltantes.length === 1) {
      return {
        firstFocusKey,
        modalType: 'warning',
        title: 'Campo obligatorio incompleto',
        description: camposFaltantes[0].hint,
        detail: {
          text: 'Campo requerido:',
          highlight: camposFaltantes[0].label,
          subtext: 'Se resaltó el campo en rojo para que pueda completarlo.',
        },
        ringBadge: true,
        confirmText: 'Entendido',
      };
    }

    if (camposFaltantes.length > 1) {
      return {
        firstFocusKey,
        modalType: 'warning',
        title: 'Faltan datos por completar',
        description: 'Se resaltaron en rojo los campos obligatorios pendientes:',
        detail: (
          <Box sx={{ width: '100%', textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            {camposFaltantes.map((campo) => (
              <Box key={campo.label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#F59E0B', flexShrink: 0 }} />
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#0F172A', fontSize: '0.88rem' }}>
                  {campo.label}
                </Typography>
              </Box>
            ))}
          </Box>
        ),
        ringBadge: true,
        confirmText: 'Revisar campos',
      };
    }

    if (nuevosErrores.cupo) {
      return {
        firstFocusKey: 'cupo',
        modalType: 'warning',
        title: 'Cupo inválido',
        description: nuevosErrores.cupo,
        detail: { text: 'Valor ingresado:', highlight: String(cupo) },
        ringBadge: true,
        confirmText: 'Corregir',
      };
    }

    if (nuevosErrores.horas) {
      return {
        firstFocusKey: 'horas',
        modalType: 'warning',
        title: 'Cantidad de horas inválida',
        description: nuevosErrores.horas,
        detail: { text: 'Valor ingresado:', highlight: String(horas) },
        ringBadge: true,
        confirmText: 'Corregir',
      };
    }

    if (nuevosErrores.sinCohortes) {
      return {
        firstFocusKey: 'cohortesSection',
        modalType: 'warning',
        title: 'Sin cohortes cargadas',
        description: 'Debe agregar al menos una cohorte con sus fechas de inscripción y cursada.',
        detail: {
          text: 'Acción requerida:',
          highlight: 'Agregar Cohorte',
          subtext: 'Utilice el botón "+ Agregar Cohorte" al pie del formulario.',
        },
        ringBadge: true,
        confirmText: 'Entendido',
      };
    }

    if (modalCohortError) {
      return {
        firstFocusKey: 'cohortesSection',
        ...modalCohortError,
      };
    }

    const codCurso = cursos.find((curso) => curso.nombre === selectCurso)?.cod;
    if (!codCurso) {
      setFieldErrors({ curso: 'El curso seleccionado no es válido. Elija uno de la lista.' });
      return {
        firstFocusKey: 'curso',
        modalType: 'error',
        title: 'Curso no válido',
        description: 'El curso seleccionado no se encontró en el catálogo disponible.',
        confirmText: 'Entendido',
      };
    }

    return null;
  };

  const handleEnviarFormulario = async () => {
    const validacionError = validarFormulario();
    if (validacionError) {
      const { modalType, firstFocusKey, ...modalOptions } = validacionError;
      if (modalType === 'warning') {
        await showWarning(modalOptions);
      } else {
        await showError(modalOptions);
      }
      if (firstFocusKey) {
        focusField(firstFocusKey);
      }
      return;
    }

    setCargando(true);
    try {
      const codCurso = cursos.find((curso) => curso.nombre === selectCurso)?.cod;
      const cantidadCohortes = cohortes.length;
      const nombreCursoRegistrado = selectCurso;
      const resumenSubtexto = `${selectPlataformaDictado} • Cupo: ${cupo} • ${horas} hs`;

      const datosParaEnviar = {
        curso: codCurso,
        tipo_capacitacion: tiposCapacitaciones.find(tipo => tipo.nombre === selectTipoCapacitacion)?.cod,
        plataforma_dictado: plataformasDictado.find(plataforma => plataforma.nombre === selectPlataformaDictado)?.cod,
        medio_inscripcion: mediosInscripcion.find(medio => medio.nombre === selectMedioInscripcion)?.cod,
        cupo: parseInt(cupo),
        cantidad_horas: parseInt(horas),
        cohortes: cohortes,
        es_autogestionado: opciones.autogestionado ? 1 : 0,
        es_publicada_portal_cc: opciones.publicaPCC ? 1 : 0,
        restriccion_edad_desde: opciones.edad ? parseInt(edadDesde) : null,
        restriccion_edad_hasta: opciones.edad && edadHasta !== "Sin Restricción" ? parseInt(edadHasta) : null,
        departamentos: opciones.departamento ? departamentosSeleccionados.map(d => d.id) : [],
        cursos_correlativos: opciones.correlatividad ? cursosCorrelativosSeleccionados.map(c => c.cod) : []
      };

      await postInstancias(datosParaEnviar);

      setCargando(false);
      limpiarFormularioCompleto();
      window.scrollTo({ top: 0, behavior: 'smooth' });

      await showSuccess({
        title: cantidadCohortes > 1 ? '¡Cohortes registradas exitosamente!' : '¡Cohorte registrada exitosamente!',
        description:
          cantidadCohortes > 1
            ? `Se registraron las ${cantidadCohortes} cohortes correctamente en el sistema.`
            : 'La cohorte fue registrada correctamente en el sistema.',
        detail: {
          text: 'Curso:',
          highlight: nombreCursoRegistrado,
          subtext: resumenSubtexto,
        },
        confirmText: 'Aceptar',
      });

    } catch (err) {
      setCargando(false);
      const mensajeError = err.message || 'Ocurrió un error al intentar guardar la cohorte.';
      let targetFocus = null;

      const matchFecha = mensajeError.match(/\d{4}-\d{2}-\d{2}/);
      if (matchFecha) {
        const fechaConflicto = matchFecha[0];
        const cohorteAfectada = cohortes.find(
          (c) => c.fechaCursadaDesde === fechaConflicto || c.fechaCursadaHasta === fechaConflicto
        );
        if (cohorteAfectada) {
          const campoConflicto =
            cohorteAfectada.fechaCursadaHasta === fechaConflicto && mensajeError.toLowerCase().includes('fin')
              ? 'fechaCursadaHasta'
              : 'fechaCursadaDesde';
          setErroresCohortes((prev) => ({
            ...prev,
            [cohorteAfectada.id]: {
              ...(prev[cohorteAfectada.id] || {}),
              [campoConflicto]: mensajeError,
            },
          }));
          targetFocus = 'cohortesSection';
        }
      } else if (mensajeError.toLowerCase().includes('cupo') || mensajeError.toLowerCase().includes('cursos')) {
        if (cohortes.length > 0) {
          const primeraCohorte = cohortes[0];
          setErroresCohortes((prev) => ({
            ...prev,
            [primeraCohorte.id]: {
              ...(prev[primeraCohorte.id] || {}),
              fechaCursadaDesde: mensajeError,
            },
          }));
          targetFocus = 'cohortesSection';
        }
      }

      await showError({
        title: 'No se pudo registrar la cohorte',
        description: mensajeError,
        detail: selectCurso
          ? {
              text: 'Curso:',
              highlight: selectCurso,
              subtext: 'Se marcó en rojo el campo con conflicto para su corrección.',
            }
          : null,
        confirmText: 'Entendido',
      });

      if (targetFocus) {
        focusField(targetFocus);
      }
    }
  };

  const inputStyles = {
    '& .MuiInputBase-input': { 
      fontSize: '16px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    '& .MuiInputLabel-root': { 
      fontSize: '16px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      maxWidth: '90%'
    }
  };

  return (
    <>
      {nuevoEvento ? <NuevoEvento setNuevoEvento={setNuevoEvento} setOpenAlertDialog={setOpenAlertDialog} setTituloAlerta={setTituloAlerta} setMensajeAlerta={setMensajeAlerta} selectCurso={selectCurso} onEventoCreado={handleEventoCreado} /> :
        <Container maxWidth={false} sx={{ mt: 4, mb: 4, px: { xs: 2, md: 5 } }}>
          <Box sx={{ mb: 2 }}>
            <Titulo texto='Crear Cohorte' />
          </Box>
          <Divider sx={{ marginBottom: 3, borderBottomWidth: 2, borderColor: 'common.black' }} />
          
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={cargando}
          >
            <BurbujasLoader />
          </Backdrop>

          <Box component="form" id="form-crear-instancia" noValidate sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

            {/* Info Curso */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  inputRef={(el) => { fieldRefs.current.curso = el; }}
                  options={cursos.filter(c => ['PVICT', 'EC'].includes(c.estado)).map(c => c.nombre).sort((a, b) => a.localeCompare(b))}
                  label={"Seleccione un curso"}
                  value={selectCurso}
                  error={Boolean(fieldErrors.curso)}
                  helperText={fieldErrors.curso || ""}
                  getValue={(value) => {
                    setSelectCurso(value);
                    if (value) clearFieldError('curso');
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  inputRef={(el) => { fieldRefs.current.medioInscripcion = el; }}
                  options={mediosInscripcion.filter(m => m.esVigente === 1).map(m => m.nombre).sort((a, b) => a.localeCompare(b))}
                  label={"Seleccione medio de inscripción"}
                  value={selectMedioInscripcion}
                  error={Boolean(fieldErrors.medioInscripcion)}
                  helperText={fieldErrors.medioInscripcion || ""}
                  getValue={(value) => {
                    setSelectMedioInscripcion(value);
                    if (value) clearFieldError('medioInscripcion');
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  inputRef={(el) => { fieldRefs.current.plataformaDictado = el; }}
                  options={plataformasDictado.filter(p => p.esVigente === 1).map(p => p.nombre).sort((a, b) => a.localeCompare(b))}
                  label={"Seleccione plataforma de dictado"}
                  value={selectPlataformaDictado}
                  error={Boolean(fieldErrors.plataformaDictado)}
                  helperText={fieldErrors.plataformaDictado || ""}
                  getValue={(value) => {
                    setSelectPlataformaDictado(value);
                    if (value) clearFieldError('plataformaDictado');
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  inputRef={(el) => { fieldRefs.current.tipoCapacitacion = el; }}
                  options={tiposCapacitaciones.filter(t => t.esVigente === 1).map(t => t.nombre).sort((a, b) => a.localeCompare(b))}
                  label={"Seleccione tipo de capacitación"}
                  value={selectTipoCapacitacion}
                  error={Boolean(fieldErrors.tipoCapacitacion)}
                  helperText={fieldErrors.tipoCapacitacion || ""}
                  getValue={(value) => {
                    setSelectTipoCapacitacion(value);
                    if (value) clearFieldError('tipoCapacitacion');
                  }}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField 
                  inputRef={(el) => { fieldRefs.current.cupo = el; }}
                  label={"Cupo"} 
                  error={Boolean(fieldErrors.cupo)}
                  helperText={fieldErrors.cupo || ""}
                  getValue={(value) => {
                    if (value === "" || /^[1-9]\d*$/.test(value)) {
                      setCupo(value);
                      if (value !== "") clearFieldError('cupo');
                    }
                  }} 
                  value={cupo} 
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  inputRef={(el) => { fieldRefs.current.horas = el; }}
                  label={"Cantidad de horas"}
                  error={Boolean(fieldErrors.horas)}
                  helperText={fieldErrors.horas || ""}
                  getValue={(value) => {
                    if (value === "" || /^[1-9]\d*$/.test(value)) {
                      setHoras(value);
                      if (value !== "") clearFieldError('horas');
                    }
                  }}
                  value={horas}
                />
              </Grid>
            </Grid>

            {/* Opciones Evento */}
            <Box>
              <OpcionesEvento opciones={opciones} onOpcionesChange={manejarCambioOpciones} />
            </Box>

            {/* Restricciones */}
            <Stack spacing={2}>
              {opciones.edad && (
                <Grid container spacing={2}>
                  <Grid item xs={6} md={3}>
                    <TextField label="Edad desde" type="number" value={edadDesde} getValue={(value) => { if (value >= 16) setEdadDesde(value); }} />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <MuiTextField select label="Edad hasta" value={edadHasta} onChange={(e) => { const value = e.target.value; if (value === "Sin Restricción" || value >= edadDesde) setEdadHasta(value); }} fullWidth sx={inputStyles}>
                      <MenuItem value="Sin Restricción" sx={{ fontSize: '16px' }}>Sin Restricción</MenuItem>
                      {Array.from({ length: 83 }, (_, i) => i + 18).map((edad) => (<MenuItem key={edad} value={edad} disabled={edad < edadDesde} sx={{ fontSize: '16px' }}>{edad}</MenuItem>))}
                    </MuiTextField>
                  </Grid>
                </Grid>
              )}
              {opciones.departamento && (
                <Box>
                  <MuiAutocomplete 
                    multiple 
                    options={departamentos} 
                    getOptionLabel={(option) => option.nombre} 
                    value={departamentosSeleccionados} 
                    onChange={(event, newValue) => {
                      setDepartamentosSeleccionados(newValue);
                      if (newValue.length > 0) clearFieldError('departamentos');
                    }} 
                    sx={{
                      '& .MuiAutocomplete-input': {
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                      }
                    }}
                    renderOption={(props, option) => (
                      <li {...props} style={{ whiteSpace: 'normal', wordBreak: 'break-word', fontSize: '14px' }}>
                        {option.nombre}
                      </li>
                    )}
                    renderInput={(params) => (
                      <MuiTextField
                        {...params}
                        inputRef={(el) => { fieldRefs.current.departamentos = el; }}
                        variant="standard"
                        label="Seleccione departamentos"
                        placeholder="Departamentos"
                        error={Boolean(fieldErrors.departamentos)}
                        helperText={fieldErrors.departamentos || ""}
                        sx={inputStyles}
                      />
                    )} 
                  />
                </Box>
              )}
              {opciones.correlatividad && (
                <Box>
                  <MuiAutocomplete 
                    multiple 
                    options={cursos} 
                    getOptionLabel={(option) => option.nombre} 
                    value={cursosCorrelativosSeleccionados} 
                    onChange={(event, newValue) => {
                      setCursosCorrelativosSeleccionados(newValue);
                      if (newValue.length > 0) clearFieldError('correlatividad');
                    }} 
                    sx={{
                      '& .MuiAutocomplete-input': {
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                      }
                    }}
                    renderOption={(props, option) => (
                      <li {...props} style={{ whiteSpace: 'normal', wordBreak: 'break-word', fontSize: '14px' }}>
                        {option.nombre}
                      </li>
                    )}
                    renderInput={(params) => (
                      <MuiTextField
                        {...params}
                        inputRef={(el) => { fieldRefs.current.correlatividad = el; }}
                        variant="standard"
                        label="Seleccione cursos correlativos"
                        placeholder="Cursos"
                        error={Boolean(fieldErrors.correlatividad)}
                        helperText={fieldErrors.correlatividad || ""}
                        sx={inputStyles}
                      />
                    )} 
                  />
                </Box>
              )}
            </Stack>


            {/* Cohortes */}
            <Box ref={(el) => { fieldRefs.current.cohortesSection = el; }}>
              <Cohortes
                getCohortes={handleCohortes}
                key={resetCohortesKey}
                esCampusCordoba={esCampusCordoba}
                esExcepcionParaFechas={esExcepcionParaFechas}
                instanciasExistentes={instanciasExistentes}
                erroresCohortes={erroresCohortes}
                errorSinCohortes={fieldErrors.sinCohortes || ""}
                onRevalidateCohortes={revalidarCohortesEnVivo}
                onClearSinCohortes={() => clearFieldError('sinCohortes')}
              />
            </Box>

            {/* Submit */}
            <Box sx={{ display: 'flex', mt: 3 }}>
              <MuiButton
                variant="contained"
                color="primary"
                onClick={handleEnviarFormulario}
                sx={{
                  ml: 'auto',
                  borderRadius: '8px',
                  px: 4,
                  py: 1,
                  fontSize: '16px',
                  fontWeight: 'bold',
                  width: 'fit-content'
                }}
              >
                REGISTRAR
              </MuiButton>
            </Box>
          </Box>
        </Container>
      }
      {<Alerta openAlertDialog={openAlertDialog} setOpenAlertDialog={setOpenAlertDialog} titulo={tituloAlerta} mensaje={mensajeAlerta} />}
    </>
  );
}
